import { mapValues } from 'lodash';

const defaultParams = {
  page: 0,
  pageSize: 20,
  filters: {},
};

export const getTableMeta = identifier => {
  const data = localStorage.getItem(`table-${identifier}`);
  if (data) {
    return JSON.parse(data);
  }
  return defaultParams;
};

const setTableMeta = (identifier, data) => {
  localStorage.setItem(`table-${identifier}`, JSON.stringify(data));
};

export const setLsPage = (identifier, page) => {
  const params = getTableMeta(identifier);
  const newParams = { ...params, page };
  setTableMeta(identifier, newParams);
};
export const setLsPageSize = (identifier, pageSize) => {
  const params = getTableMeta(identifier);
  const newParams = { ...params, pageSize };
  setTableMeta(identifier, newParams);
};
export const setLsSorted = (identifier, sorted) => {
  const params = getTableMeta(identifier);
  const newParams = { ...params, sorted };
  setTableMeta(identifier, newParams);
};
export const setLsFilters = (identifier, filters) => {
  const params = getTableMeta(identifier);
  const newParams = { ...params, filters };
  setTableMeta(identifier, newParams);
};

export const getPagingParams = (tableMeta, pageIncr = 0) => {
  const {
    page = 0,
    pageSize = 20,
    sorted,
    filters = {},
    searchText = '',
  } = tableMeta;
  const newPage = page + pageIncr;
  const skipCount = newPage * pageSize;
  const maxResultCount = pageSize;
  const sorting =
    sorted && sorted.length
      ? `${sorted[0].id} ${sorted[0].desc ? 'desc' : ''}`
      : '';
  const encodedFilters = mapValues(filters, f =>
    f ? encodeURIComponent(f) : ''
  );
  return {
    skipCount,
    maxResultCount,
    sorting,
    ...encodedFilters,
    searchText,
  };
};

export const getPagingParamsFromLocalStorage = identifier => {
  const tableMeta = getTableMeta(identifier);
  return getPagingParams(tableMeta);
};

export const clearTagFromTableFilters = tagId => {
  const keys = Object.keys(localStorage).filter(f =>
    f.startsWith('table-userentry')
  );
  keys.forEach(key => {
    const identifier = key.replace('table-', '');
    const meta = getTableMeta(identifier);
    if (meta.filters.tag === tagId) {
      meta.filters.tag = 'all';
      setLsFilters(identifier, meta.filters);
    }
  });
};
